import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { POPUP } from 'Component/Header/Header.config';
import { changeNavigationState, goToPreviousNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { hideActiveOverlay, hideActivePopup } from 'Store/Overlay/Overlay.action';
import { ChildrenType, MixType } from 'Type/Common.type';
import { noopFn } from 'Util/Common';

import Popup from './Popup.component';

/** @namespace Bodypwa/Component/Popup/Container/mapStateToProps */
const mapStateToProps = (state) => ({
    activeOverlay: state.OverlayReducer.activeOverlay,
    areOtherOverlaysOpen: state.OverlayReducer.areOtherOverlaysOpen,
    shouldPopupClose: state.PopupReducer.shouldPopupClose,
    payload: state.PopupReducer.popupPayload,
    isMobile: state.ConfigReducer.device.isMobile
});

/** @namespace Bodypwa/Component/Popup/Container/mapDispatchToProps */
const mapDispatchToProps = (dispatch) => ({
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    resetHideActivePopup: () => dispatch(hideActivePopup(false)),
    changeHeaderState: (state) => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, state)),
    goToPreviousNavigationState: (state) => dispatch(goToPreviousNavigationState(TOP_NAVIGATION_TYPE, state))
});

/** @namespace Bodypwa/Component/Popup/Container */
export class PopupContainer extends PureComponent {
    static propTypes = {
        mix: MixType,
        contentMix: MixType,
        payload: PropTypes.objectOf(
            PropTypes.shape({
                title: PropTypes.string
            })
        ).isRequired,
        activeOverlay: PropTypes.string.isRequired,
        goToPreviousNavigationState: PropTypes.func.isRequired,
         
        areOtherOverlaysOpen: PropTypes.bool.isRequired,
        changeHeaderState: PropTypes.func.isRequired,
        onVisible: PropTypes.func,
        onClose: PropTypes.func,
        onHide: PropTypes.func,
        isStatic: PropTypes.bool,
        children: ChildrenType,
        id: PropTypes.string.isRequired,
         
        shouldPopupClose: PropTypes.bool.isRequired,
        isMobile: PropTypes.bool.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        resetHideActivePopup: PropTypes.func.isRequired,
        isContainer: PropTypes.bool,
         
        clickOutside: PropTypes.bool,
         
        checkmark: PropTypes.bool,
        isNoTransition: PropTypes.bool,
        popUpHeight: PropTypes.number,
        isHideHeader: PropTypes.bool,
         
        headerRef: PropTypes.object,
        overlayHtml: PropTypes.string,
        title: PropTypes.string,
        isGoBack: PropTypes.bool.isRequired,
        onCustomClose: PropTypes.func.isRequired,
        className: PropTypes.string,
        iconPosition: PropTypes.string,
        headerPosition: PropTypes.string,
        clssWidthPopup: PropTypes.string,
        hideButton: PropTypes.string,
        noPadding: PropTypes.string,
        icon: PropTypes.elementType,
        closeOnBrowserBack: PropTypes.bool
    };

    static defaultProps = {
        onVisible: noopFn,
        onClose: noopFn,
        onHide: noopFn,
        mix: {},
        contentMix: {},
        children: [],
        isStatic: false,
        clickOutside: true,
        checkmark: false,
        isNoTransition: false,
        popUpHeight: 0,
        isHideHeader: false,
        headerRef: null,
        overlayHtml: '',
        title: '',
        className: '',
        iconPosition: '',
        headerPosition: '',
        clssWidthPopup: 'max-w-490 w-full',
        isContainer: false,
        hideButton: '',
        noPadding: '',
        icon: null
    };

    containerFunctions = {
        onVisible: this.onVisible.bind(this),
        hasConatiner: this.hasConatiner.bind(this)
    };

    state = {
        isClosing: false
    };

    onVisible() {
        const { changeHeaderState, onVisible } = this.props;

        changeHeaderState({
            name: POPUP,
            title: this._getPopupTitle(),
            onCloseClick: () => {
                history.back();
            }
        });

        onVisible();
    }

    setIsClosing = (isClosing) => {
        this.setState({ isClosing });
    };

    containerProps() {
        const {
            clickOutside,
            checkmark = false,
            isNoTransition = false,
            popUpHeight,
            isHideHeader = false,
            headerRef,
            overlayHtml = '',
            activeOverlay,
            areOtherOverlaysOpen,
            changeHeaderState,
            children,
            id,
            isMobile,
            isStatic,
            mix,
            contentMix,
            onClose,
            onHide,
            onVisible,
            shouldPopupClose,
            hideActiveOverlay,
            resetHideActivePopup,
            goToPreviousNavigationState,
            isGoBack = true,
            onCustomClose,
            className,
            iconPosition,
            headerPosition,
            clssWidthPopup,
            hideButton,
            noPadding,
            zIndex,
            icon,
            closeOnBrowserBack
        } = this.props;

        const { isClosing } = this.state;

        return {
            // ...super.containerProps(),
            clickOutside,
            checkmark,
            isClosing,
            isNoTransition,
            popUpHeight,
            isHideHeader,
            headerRef,
            setIsClosing: this.setIsClosing,
            overlayHtml,
            activeOverlay,
            areOtherOverlaysOpen,
            changeHeaderState,
            children,
            id,
            isMobile,
            isStatic,
            mix,
            contentMix,
            shouldPopupClose,
            onClose,
            onHide,
            onVisible,
            hideActiveOverlay,
            resetHideActivePopup,
            goToPreviousNavigationState,
            title: this._getPopupTitle(),
            onCustomClose,
            isGoBack,
            className,
            iconPosition,
            headerPosition,
            clssWidthPopup,
            hideButton,
            noPadding,
            zIndex,
            icon,
            closeOnBrowserBack
        };
    }

    _getPopupTitle() {
        const { payload, activeOverlay, title: ogTitle } = this.props;
        const { title } = payload[activeOverlay] || {};

        return ogTitle || title;
    }

    hasConatiner() {
        const { payload: { isContainer }, isContainer: isContainerOg } = this.props;
        return isContainer || isContainerOg || false;
    }

    render() {
        return (
            <Popup
                isContainer
                { ...this.containerProps() }
                { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupContainer);
